export const links = {
  job: "https://www.linkedin.com/jobs/view/3303164715/",
};
